const canUseWindow = !!(typeof window !== 'undefined');

const getWindow: () => Window | null = canUseWindow ? () => window : () => null;

export default getWindow;
